<div class="custom-scrollbar_wrapper" #wrapper>
  <div class="custom-scrollbar_container" #container>
    <ng-content></ng-content>
  </div>

  <div class="custom-scrollbar_ending-blind -top" #topEndingBlind></div>
  <div class="custom-scrollbar_ending-blind -bottom" #bottomEndingBlind></div>
  <div class="custom-scrollbar_ending-blind -left" #leftEndingBlind></div>
  <div class="custom-scrollbar_ending-blind -right" #rightEndingBlind></div>

  @if (!scrollingBarHorizontal) {
    <scrollingBar horizontal #innerScrollingBarHorizontal></scrollingBar>
  }
  @if (!scrollingBarVertical) {
    <scrollingBar vertical #innerScrollingBarVertical></scrollingBar>
  }

  <div class="custom-scrollbar_scroll-calculate" #calculateScrollWidthHelper>
    <div class="custom-scrollbar_scroll-calculate-body"></div>
  </div>
</div>
